<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div id="main-container">

      <div id="algolia-content-container" class="data-list-container">

        <vs-table ref="table" class="pb-5" search pagination :max-items="itemsPerPage" :data="companies">

          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

            <vs-button color="primary" type="border" icon-after icon="add" @click="showCreateCompanyDialog">Add New Company</vs-button>

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ companies.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : companies.length }} of {{ companies.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>

                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>


          <template slot="thead">
            <vs-th sort-key="company_id">ID</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="active">Active</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody :data="company" :key="indextr" v-for="(company, indextr) in data" @click="goToCompanyDetail(company.company_id)">
            <vs-tr class="cursor-pointer">

              <vs-td>
                <p class="product-name font-medium truncate">{{ company.company_id }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ company.name }}</p>
              </vs-td>

              <vs-td>
                <vs-chip v-if="company.active === 1" color="success">Yes</vs-chip>
                <vs-chip v-if="company.active === 0" color="warning">No</vs-chip>
              </vs-td>

            </vs-tr>
            </tbody>
          </template>

        </vs-table>

      </div>
    </div>



    <vs-prompt
      @accept="createCompany"
      title="New Company"
      :active.sync="showCreateCompanyDialogFlag">
      <div>

        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              :label-placeholder="`Company Name`"
              v-model="newCompanyModel.name"
              class="w-full"
            />
          </div>
        </div>

      </div>
    </vs-prompt>

<!--    <div v-html="jp.toHtml(companies)"></div>-->
  </div>
</template>

<script>
  import api from '@/http/api';
  import models from '@/models';
  import jsonPrinter from '@/misc/jsonHtmlPrinter';

  export default {
    components: {},
    data() {
      return {
        showCreateCompanyDialogFlag: false,
        models: models,
        isSearchStalled: false,
        currentRefinement: true,
        jp: jsonPrinter,

        isMounted: false,
        itemsPerPage: 25,

        companies: [new models.Company()],

        newCompanyModel: new models.Company(),
      }
    },
    mounted() {
      this.isMounted = true;
      this.fetchCompanies();
    },
    computed: {
      currentPage() {
        if(this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
    },
    methods: {
      async goToCompanyDetail(companyId) {
        this.showCreateCompanyDialogFlag = false;
        // just give the UI enough time to close the dialog
        await new Promise(resolve => setTimeout(resolve, 300));
        this.$router.push(`/content/companies/detail?id=${companyId}`).catch(() => {
        });
      },
      showCreateCompanyDialog() {
        this.newCompanyModel = new models.Company();
        this.showCreateCompanyDialogFlag = true;

      },
      async createCompany() {
        if (this.newCompanyModel.name === '') return;
        this.isSearchStalled = true;

        let newCompany = await api.createNewCompany(this.newCompanyModel);
        this.isSearchStalled = false;

        if (newCompany !== null && newCompany.company_id > 0) {
          this.goToCompanyDetail(newCompany.company_id);
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Error creating company',
            color: 'danger',
            icon: 'error'});
        }

      },
      async fetchCompanies() {
        this.isSearchStalled = true;
        let companiesObj = await api.fetchAllCompanies();

        this.companies = companiesObj.companies;
        this.isSearchStalled = false;
      },

    },
  }

</script>

